import { Component, inject, OnInit } from '@angular/core';
import { NavigationStart, RouterOutlet } from '@angular/router';
import { LanguageService } from './core/services/language/language.service';
import { Router, Event } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { ProgressSpinnerComponent } from './features/progress-spinner/progress-spinner';
import { AllStatus } from './core/services/status/all-status';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ProgressSpinnerComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit{
  router = inject(Router);
  protected title = 'nutrimind-game';
  languageService: LanguageService = inject(LanguageService);
  allStatus$ = inject(AllStatus);

  color:ThemePalette = 'warn';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 50;

  ngOnInit(){
    this.router.events
    .pipe(filter((event: Event): event is NavigationStart => event instanceof NavigationStart))
    .subscribe((event: NavigationStart) => {
      if(event?.url.includes("share=true")){
        let urlStory = event?.url.slice(9, 45);
        sessionStorage.setItem("shareStory", urlStory);
        
      }
    });

    this.languageService.catchAppLanguage$();
  }
}
